export class DOM {
  constructor (el) {
    this.$root = document.querySelector(el)
  }

  create (el, id) {
    el = document.createElement(el)
    el.id = id
    return el
  }

  style (el, styles) {
    if (typeof el === 'string') {
      el = this.find(el)
    }
    for (let style in styles) {
      el.style[style] = styles[style]
    }
  }

  add (src, el) {
    if (typeof src === 'string') {
      this.find(src).appendChild(el)
    } else {
      src.appendChild(el)
    }
  }

  remove (src, el) {
    if (typeof src === 'string') {
      this.find(src).removeChild(el)
    } else {
      src.removeChild(el)
    }
  }

  find (queryStr) {
    return document.querySelector(queryStr)
  }

  findAll (queryStr) {
    return document.querySelectorAll(queryStr)
  }

  each (arrayLike, fn) {
    for (let i = 0; i < arrayLike.length; i++) {
      fn(arrayLike[i], i)
    }
  }

  children (el) {
    return (typeof el === 'string') ? this.find(el).children : el.children
  }

  attr (el, name, value) {
    el.setAttribute(name, value)
  }

  rect (el) {
    return el.getBoundingClientRect()
  }
}



// WEBPACK FOOTER //
// ./src/Services/tableLayoutHelper/DOM.js